export default "__VITE_ASSET__1cJE6zR9__"